import { put, takeLatest, call, all } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';

// GET_PROFIT
function* getProfit() {
  try {
    const { data, status } = yield call(api.wallets.getProfit);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_PROFIT_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_PROFIT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* profit() {
  yield takeLatest(types.GET_PROFIT_START, getProfit);
}
